import update from 'immutability-helper';
import { RESET_STATE, TOGGLE_ADD_FIELD, 
  TOGGLE_ALLOW_FIELD} from 'constants/actionTypes';

const initialState = {
  allowed: {},
  added: {},
};

const resetCheckboxState = values => {
  const checkboxes = {
    allowed: {},
    added: {}
  };

  Object.entries(values).forEach(([predicate, _]) => {
    checkboxes.allowed[predicate] = false;
    checkboxes.added[predicate] = false;
  });

  return checkboxes;
};

export default function(state = initialState, action) {
  switch(action.type) {
  case RESET_STATE:
    // eslint-disable-next-line no-case-declarations
    const checkboxes = resetCheckboxState(state.allowed);

    return {
      ...state,
      allowed: checkboxes.allowed,
      added: checkboxes.added,
    };

  case TOGGLE_ADD_FIELD:
    return {
      ...state,
      added: update(state.added,  {
        [action.predicate]: {
          $set: !state.added[action.predicate]
        }
      })
    };

  case TOGGLE_ALLOW_FIELD:
    return {
      ...state,
      allowed: update(state.allowed,  {
        [action.predicate]: {
          $set: !state.allowed[action.predicate]
        }
      })
    };

  default:
    return state;
  }
}